import axios from 'axios';

import store from '../store';

const rewardsApi = axios.create({
  baseURL: process.env.REACT_APP_REWARDS_API_URL,
});

rewardsApi.interceptors.request.use(config => {
  const outputConfig = config;

  const state = store.getState();
  const { authenticated, user } = state.auth;

  if (authenticated) {
    outputConfig.headers.authorization = `${user.token.type} ${user.token.token}`;
  }

  return outputConfig;
});

export default rewardsApi;
